import React from "react";
import Footer from "../components/Footer";

function Privacy() {
  return (
    <div>
      <div className="container">
        <div className="section-title">
          <h2 className="pt-5">PRIVACY POLICY</h2>
          <p className="lead pt-5">
            Head Hunting Agency is committed to the highest standard of privacy.
            This includes the privacy of all individuals and organizations that
            we interact with. This privacy policy explains how Head Hunting
            Agency handles personal and company data for those using our
            services and tools. Head Hunting Agency protects the privacy of
            individuals taking our surveys, participating in our events, as well
            as being interviewed by us, We will not share, sell, rent, swap, or
            authorize any third party to use email addresses for commercial
            purposes. Our projects are strictly confidential and we do
            everything we can to protect the individuals and organizations that
            take part in our processes. We will not in any way reprint, resell,
            or redistribute your organization’s details and sensitive
            information to anyone, unless you specifically instruct us to do so.
            For Remuneration and Market Mapping surveys purposes, HHA reserves
            the right to aggregate your data into comparative benchmarks that
            are presented to our clients or third parties. Under all
            circumstances, your organization’s data will be combined with
            multiple organizations, and your organization’s identity will never
            be revealed. Head Hunting Agency protects the privacy of individuals
            who visit our websites. When you submit personal information to us,
            we collect and store that information, such as your name, title,
            email address, etc. We use this information to allow administration
            and communication with you regarding recruitment processes.. We may
            also use your email address to send you updates and provide services
            to you. We will not share, sell, rent, swap, or authorize any third
            party to use users’ email addresses for commercial purposes. Head
            Hunting Agency processes adhere to the EU-US Privacy Shield
            principles of Notice, Choice, Accountability for Onward Transfer,
            Security, Data Integrity and Purpose Limitation, Access, and
            Recourse, Enforcement and Liability. Head Hunting Agency may make
            changes to its privacy policy to align with our operations and
            evolving laws. If we make changes to this privacy policy, we will
            post those changes here and in other appropriate places. We reserve
            the right to modify this privacy policy at any time, so please
            review it regularly. This privacy notice is currently only available
            in English. In compliance with Romanian and European Privacy Policy,
            Head Hunting Agency is committed to resolving complaints in a timely
            manner. Individuals with inquiries or complaints regarding our
            Privacy Policy should first contact Head Hunting Agency at
            privacy@hha.ro or send an email to Loreda Silvia Dragomir The Data
            Protection Officer loreda.dragomir@hha.ro Please allow up to 48
            hours for a response.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Privacy;
